import { SearchUserHit } from 'lib-shared-types-api';

type CanMakeInternalCallParams = {
  member: SearchUserHit;
  isOwnAgent: boolean;
  isMicrophoneBlocked: boolean;
};

export const canMakeInternalCall = ({
  member,
  isOwnAgent,
  isMicrophoneBlocked,
}: CanMakeInternalCallParams): boolean => {
  const hasActivePhoneCall = (member.workloads_by_channel?.pstn_phone ?? 0) > 0;
  const isOffline = !member.is_online;
  const hasPhoneDisabled = !member.working_media_types?.includes('speak');

  return !(
    hasActivePhoneCall ||
    isMicrophoneBlocked ||
    isOwnAgent ||
    isOffline ||
    hasPhoneDisabled
  );
};
